import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { TextReveal } from './ui/Reveal';
import { projects } from '../data/work';
export function SelectedWork() {
  return <section id="work" className="w-full bg-[#F2F2F2] px-5 py-20 lg:px-8 lg:py-24" data-id="element-167" data-mp="3npuz2qvzc772">
      <div className="mx-auto w-full max-w-shell" data-id="element-168" data-mp="3iscnstuhpfvw">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center" data-id="element-169" data-mp="3du1fwonr9fgb">
          <h2 className="max-w-[620px] text-3xl font-semibold leading-tight text-[#2D2D2D] lg:text-[40px] lg:leading-[48.8px]" data-id="element-170" data-mp="38u5jpblausbb">
            <TextReveal data-id="element-171" data-mp="34td9og4lsjdz">Turn your ideas into impactful</TextReveal>
            <br className="hidden sm:block" data-id="element-172" data-mp="2zuihinkqxih7" /> <TextReveal data-id="element-173" data-mp="2zvbhn5p799qd">solutions like them!</TextReveal>
          </h2>
          <Button to="/#contact" variant="solid" data-id="element-174" data-mp="131qgq915ieev">
            Start Project
          </Button>
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-x-6 gap-y-10 md:grid-cols-2" data-id="element-175" data-mp="y3f6vyauw3wn">
          {projects.map((project, index) => {
          const isBig = project.slug === 'tende-pay';
          const isLogo = project.slug === 'flowkey';
          return <motion.li key={project.slug} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.5,
            delay: index % 2 * 0.1,
            ease: 'easeOut'
          }} className={`flex flex-col gap-7 ${isBig ? 'md:col-span-2' : ''}`} data-id="element-176" data-mp="1qyniq0n20fto" data-mpi={index}>
                <Link to={`/work/${project.slug}`} className="group flex flex-col gap-7" aria-label={`${project.name} case study`} data-id="element-177" data-mp="2ew301fp8sc1g">
                  <div className={`relative flex items-center justify-center overflow-hidden rounded-[40px] ${isBig ? 'aspect-[21/8]' : 'aspect-[16/10]'}`} style={{
                backgroundColor: project.cardBackground
              }} data-id="element-178" data-mp="37cdpxg9gzk7j">
                    {isBig ? <div className="absolute inset-0 flex items-center justify-center p-[5%] bg-gradient-to-br from-[#101826] to-[#0a0c11]" data-id="element-179" data-mp="378vdll87zcm7">
                        <div className="w-full max-w-[74%] h-full flex flex-col items-center justify-center" data-id="element-180" data-mp="32dg5l9ww8axp">
                          <div className="w-full min-h-0 flex flex-col rounded-t-xl rounded-b-md border border-line-2 bg-[#1a1c22] p-1.5 shadow-2xl" data-id="element-181" data-mp="2tj1pj54jgwdj">
                            <div className="flex flex-col min-h-0 rounded-md overflow-hidden bg-canvas border border-line" data-id="element-182" data-mp="2ok6vt8519nen">
                              <div className="flex items-center gap-1.5 px-3 py-2 border-b border-line flex-none" data-id="element-183" data-mp="2jihmbwxglhso">
                                <span className="w-2 h-2 rounded-full bg-[#ff5f57]" data-id="element-184" data-mp="2ajw3e0o2s0rd" />
                                <span className="w-2 h-2 rounded-full bg-[#febc2e]" data-id="element-185" data-mp="2am9yg9ir9cyx" />
                                <span className="w-2 h-2 rounded-full bg-[#28c840]" data-id="element-186" data-mp="q1lio3mxm2nk" />
                              </div>
                              <img src={project.thumb} alt={project.cover.alt} className="w-full flex-1 min-h-0 object-cover object-top block transition-transform duration-500 ease-out motion-safe:group-hover:scale-[1.03]" loading="lazy" data-id="element-187" data-mp="z2jsx3nyr6el" />
                            </div>
                          </div>
                          <div className="w-10 h-3.5 bg-[#1a1c22] border-x border-b border-line-2 flex-none" data-id="element-188" data-mp="gah95jg0za04" />
                          <div className="w-28 h-1.5 rounded-full bg-[#1a1c22] border border-line-2 flex-none" data-id="element-189" data-mp="l43bahokbvho" />
                        </div>
                      </div> : isLogo ? <div className="absolute inset-0 flex items-center justify-center p-12" data-id="element-190" data-mp="3opsiw7q2iov0">
                        <img src="https://cdn.magicpatterns.com/uploads/g3xSNcTwxUKYvMqytRpxH8/Frame_2121457531.png" alt={`${project.name} logo`} className="max-w-[62%] h-auto transition-transform duration-500 ease-out motion-safe:group-hover:scale-[1.05]" loading="lazy" data-id="element-191" data-mp="1ubww6cjuvqhg" />
                      </div> : <img src={project.thumb} alt={project.cover.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 ease-out motion-safe:group-hover:scale-[1.03]" data-id="element-192" data-mp="291cfx8kyyvnn" />}
                  </div>
                  <div className="flex flex-col gap-1.5" data-id="element-193" data-mp="nn83eioc6vfg">
                    <h3 className="text-2xl font-semibold text-[#2D2D2D] transition-colors group-hover:text-[#0000FE]" data-id="element-194" data-mp="norkgbhthaia">
                      {project.name}
                    </h3>
                    <ul className="flex flex-wrap gap-x-3 gap-y-1" data-id="element-195" data-mp="348lgu3ym2osc">
                      {project.tags.map(tag => <li key={tag} className="text-base text-[#2D2D2D]" data-id="element-196" data-mp="2qhzv87hrw0qr">
                          {tag}
                        </li>)}
                    </ul>
                  </div>
                </Link>
              </motion.li>;
        })}
        </ul>
      </div>
    </section>;
}